import React from 'react'
import styled from 'styled-components'
import InputWrapper from 'src/components/InputWrapper'
import SectionTitle from 'src/components/SectionTitle'
import WeekSelector from 'src/components/WeekSelector'
import { AppContext } from 'src/context/AppContext'

const WeekAdvancedSetting = () => (
  <AppContext.Consumer>
    {({ state }) => (
      <InputWrapper>
        <SectionTitle>
          曜日
          {state.interval === 'otherWeek' && (
            <Label>※隔週の場合は曜日を1つだけ選択できます</Label>
          )}
        </SectionTitle>
        <WeekSelector />
      </InputWrapper>
    )}
  </AppContext.Consumer>
)

export default WeekAdvancedSetting

const Label = styled.label`
  margin-left: 10px;
  display: inline-block;
  font-size: 12px;
  font-weight: normal;
  color: #000000;
`
